import * as React from 'react';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import { AppUser } from 'Src/views/App/App';
import {
  AccountSetupReminderPreview,
  getAllSchoolUsers,
  previewAccountSetupReminders,
  searchSchoolUsers,
  sendAccountSetupReminders
} from 'Src/helpers/service/admin/users';
import { parse, stringify } from 'query-string';
import moment from 'moment';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Loader } from 'Src/components/Loader/Loader';
import { createUserTag, getAllUserTags } from 'Src/helpers/service/admin/userTags';
import { SchoolUser } from 'Src/models/schoolUser';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  getEmailOrMisEmail,
  getPhoneOrMisPhone,
  getUserRole,
  getUserStatus,
  getUserTags
} from 'Src/helpers/accessor/accessor';
import { History, Location } from 'history';
import { getSelectOptionForRole, getSelectOptionForTag, getSelectOptionForUserStatus } from 'Src/helpers/table/select';
import { UserTagAssignModal } from 'Src/components/UserTagAssignModal/UserTagAssignModal';
import { UserTagDeleteModal } from 'Src/components/UserTagDeleteModal/UserTagDeleteModal';
import { updateUserTagsInBulk } from 'Src/helpers/service/admin/users';
import { Tag } from 'Src/models/tag';
import { ALL_SCHOOL_ROLES_ADDING_LIST, ROLE } from 'Src/consts/user';
import { GeneralMessageWizzard } from 'Src/components/GeneralMessageWizzard/GeneralMessageWizzard';
import { getSettingsUploadFiles } from 'Src/helpers/service/nobody/settings';
import { SimpleModal } from '../../../../../components/SimpleModal/SimpleModal';
import { SchoolUserPermission } from '../../../../../models/schoolUser';
import { ROLE_SERVER_TO_CLIENT_MAPPING } from '../../../../../consts/user';
import { UserRevokeRoleForm } from './UserRevokeRoleForm/UserRevokeRoleForm';
import propz from 'propz';
import { deleteDataToPermission, postUserPermission } from '../../../../../helpers/service/admin/staffs';
import { UserAddRoleForm } from './UserAddRoleForm/UserAddRoleForm';
import { TextUtils } from '../../../../../helpers/utils/TextUtils';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { UserActivityDetailsReportForm } from './Reports/UserActivityDetailsReportForm/UserActivityDetailsReportForm';
import { StudentActivityReportForm } from './Reports/StudentActivityReportForm/StudentActivityReportForm';
import { ParentActivityReportForm } from './Reports/ParentActivityReportForm/ParentActivityReportForm';
import { getUserTagColor } from 'Src/helpers/tags/tagColors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEnvelope, faTags, faUserShield, faUsers } from '@fortawesome/free-solid-svg-icons';
import '../Students/Students.scss';
import './Users.css';
import { countActivePeopleFilters, PeopleFilterChips } from '../PeopleFilterChips';
import { PeopleFilterChipSelect } from '../PeopleFilterChipSelect';
import { getSchoolSports } from 'Src/helpers/service/admin/user';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { PeopleListPageHeader } from '../PeopleListPageHeader';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';
const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'firstName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['firstName']
  },
  {
    text: 'Surname',
    field: 'lastName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['lastName']
  },
  {
    text: 'Email',
    field: 'email',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: getEmailOrMisEmail
  },
  {
    text: 'Phone',
    field: 'phone',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: getPhoneOrMisPhone
  },
  {
    text: 'Logged in',
    field: 'loggedIn',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: (user: SchoolUser) => (user.lastLoginAt ? 'Yes' : 'No')
  },
  {
    text: 'Last login',
    field: 'lastLoginAt',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: (user: SchoolUser) => (user.lastLoginAt ? moment(user.lastLoginAt).format('DD-MM-YYYY HH:mm') : '—')
  },
  {
    text: 'Role',
    field: 'role',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getUserRole
  },
  {
    text: 'Status',
    field: 'userStatus',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getUserStatus
  },
  {
    text: 'Tag',
    field: 'tag',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getUserTags
  }
];

const NAME_SEARCH_COLUMN: ColumnDefinition = {
  text: 'Name',
  field: 'nameSearch',
  isSort: false,
  type: FILTER_TYPE.TEXT,
  accessor: ['firstName']
};

const FILTER_COLUMNS: ColumnDefinition[] = [...COLUMNS, NAME_SEARCH_COLUMN];

function getSchoolUsersWhere(filters: any): any {
  const { loggedIn, ...otherFilters } = filters || {};
  const where = getServerFieldSectionWhere(otherFilters);
  const selected = Array.isArray(loggedIn) ? loggedIn : loggedIn ? [loggedIn] : [];
  if (selected.length === 1 && selected[0] === 'YES') where.lastLoginAt = { $exists: true };
  if (selected.length === 1 && selected[0] === 'NO') where.lastLoginAt = { $exists: false };
  return where;
}

interface State {
  items: SchoolUser[];
  currentPage: number;
  selectedItems: SchoolUser[];
  previewUser: SchoolUser | null;
  currentTabIndex: number;
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  excludedSelectionIds: string[];
  userTags: any[];
  sports: any[];
  total: number;
  basePath: string;
  maxSizeUploadFile: number;
  revokePermissions: SchoolUserPermission[];

  isMessageModalOpen: boolean;
  isUserTagModalOpen: boolean;
  isUserTagDeleteModalOpen: boolean;
  isConfirmRevokeRoleModalOpen: boolean;
  isRevokeRoleFormOpen: boolean;
  isAddRoleFormOpen: boolean;
  isUserActivityDetailsReportModalOpen: boolean; //023
  isStudentActivityReportModalOpen: boolean; //024
  isParentActivityReportModalOpen: boolean; //025
  isReportsSelectionModalOpen: boolean;
  isAccountSetupReminderModalOpen: boolean;
  isAccountSetupReminderLoading: boolean;
  isAccountSetupReminderSending: boolean;
  accountSetupReminderPreview: AccountSetupReminderPreview | null;
  accountSetupReminderLifetimeHours: 24 | 48 | 72 | 168;
  accountSetupReminderError: string;
  accountSetupReminderSuccess: string;

  errorMessage: string;
  isErrorModalOpen: boolean;

  selectedUserTagId: string;
  hiddenUserColumnKeys: string[];
  isColumnsMenuOpen: boolean;
  isSelectionMenuOpen: boolean;
  addRoleInitialPreset: string;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class Users extends React.Component<Props, State> {
  private itemsRequestId = 0;

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      previewUser: null,
      currentTabIndex: 0,
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      userTags: [],
      sports: [],
      total: 0,
      basePath: '',
      maxSizeUploadFile: 0,
      revokePermissions: [],

      isMessageModalOpen: false,
      isUserTagModalOpen: false,
      isUserTagDeleteModalOpen: false,
      isConfirmRevokeRoleModalOpen: false,
      isRevokeRoleFormOpen: false,
      isAddRoleFormOpen: false,
      isUserActivityDetailsReportModalOpen: false,
      isStudentActivityReportModalOpen: false,
      isParentActivityReportModalOpen: false,
      isReportsSelectionModalOpen: false,
      isAccountSetupReminderModalOpen: false,
      isAccountSetupReminderLoading: false,
      isAccountSetupReminderSending: false,
      accountSetupReminderPreview: null,
      accountSetupReminderLifetimeHours: 48,
      accountSetupReminderError: '',
      accountSetupReminderSuccess: '',

      errorMessage: '',
      isErrorModalOpen: false,

      selectedUserTagId: '',
      hiddenUserColumnKeys: this.getInitialHiddenUserColumnKeys(),
      isColumnsMenuOpen: false,
      isSelectionMenuOpen: false,
      addRoleInitialPreset: ''
    };
  }

  getUserColumnsStorageKey(): string {
    const { user } = this.props;
    const schoolId = propz.get(user, ['activeSchoolId'], propz.get(user, ['activeSchool', 'id'], 'school'));
    const userId = propz.get(user, ['userId'], propz.get(user, ['id'], propz.get(user, ['profile', 'id'], 'user')));
    const role = propz.get(user, ['activeRole'], 'role');

    return `sit.users.hiddenColumns:${schoolId}:${userId}:${role}`;
  }

  getInitialHiddenUserColumnKeys(): string[] {
    if (typeof window === 'undefined') {
      return [];
    }

    try {
      return JSON.parse(window.localStorage.getItem(this.getUserColumnsStorageKey()) || '[]');
    } catch (error) {
      return [];
    }
  }

  persistHiddenUserColumnKeys = (hiddenUserColumnKeys: string[]): void => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(this.getUserColumnsStorageKey(), JSON.stringify(hiddenUserColumnKeys));
    }

    this.setState({ hiddenUserColumnKeys });
  };

  toggleUserColumn = (field: string): void => {
    const hidden = new Set(this.state.hiddenUserColumnKeys);

    if (hidden.has(field)) {
      hidden.delete(field);
    } else {
      hidden.add(field);
    }

    this.persistHiddenUserColumnKeys(Array.from(hidden));
  };

  resetUserColumns = (): void => {
    this.persistHiddenUserColumnKeys([]);
  };

  onDocumentClick = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;

    if (
      target &&
      target.closest &&
      (target.closest('.people-columns') ||
        target.closest('.people-filter') ||
        target.closest('.people-filterBtn') ||
        target.closest('.people-bulkSelect'))
    ) {
      return;
    }

    const shouldRestoreFilters = this.state.isShowFilter;
    this.setState({ isColumnsMenuOpen: false, isShowFilter: false, isSelectionMenuOpen: false });
    if (shouldRestoreFilters) this.setItems();
  };

  onDocumentKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      const shouldRestoreFilters = this.state.isShowFilter;
      this.setState({ isColumnsMenuOpen: false, isShowFilter: false, isSelectionMenuOpen: false });
      if (shouldRestoreFilters) this.setItems();
    }
  };

  onUserPreviewClick = (user: SchoolUser): void => {
    this.setState({
      previewUser: user,
      currentTabIndex: 0
    });
  };

  closeUserPreview = (): void => {
    this.setState({
      previewUser: null,
      currentTabIndex: 0
    });
  };

  usePreviewUserForAction = (callback?: () => void): void => {
    const { previewUser } = this.state;

    if (!previewUser) {
      return;
    }

    this.setState(
      {
        selectedItems: [previewUser],
        isSelectAllChecked: false
      },
      callback
    );
  };

  onUserRowCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>, user: SchoolUser): void => {
    event.stopPropagation();

    if (this.state.isSelectAllChecked) {
      const excludedSelectionIds = [...this.state.excludedSelectionIds];
      const excludedIndex = excludedSelectionIds.indexOf(user.id);
      if (excludedIndex === -1) {
        excludedSelectionIds.push(user.id);
      } else {
        excludedSelectionIds.splice(excludedIndex, 1);
      }
      this.setState({ excludedSelectionIds });
      return;
    }

    const selectedItems = [...this.state.selectedItems];
    const selectedItemIndex = selectedItems.findIndex(item => item.id === user.id);

    if (selectedItemIndex === -1) {
      selectedItems.push(user);
    } else {
      selectedItems.splice(selectedItemIndex, 1);
    }

    this.setState({ selectedItems });
  };

  onModernFilterChange = (field: string, value: string): void => {
    const filters = { ...this.state.filters };

    if (value === '') {
      delete filters[field];
    } else {
      const filter = FILTER_COLUMNS.find(col => col.field === field);
      filters[field] = filter && filter.type === FILTER_TYPE.MULTISELECT ? [value] : value;
    }

    this.setState({ filters });
  };

  onModernMultiFilterToggle = (field: 'role' | 'userStatus' | 'tag', value: string): void => {
    const current = Array.isArray(this.state.filters[field])
      ? this.state.filters[field]
      : this.state.filters[field]
      ? [this.state.filters[field]]
      : [];
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: current.indexOf(value) === -1 ? [...current, value] : current.filter(item => item !== value)
      }
    });
  };

  onModernFilterKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onApplyFilterClick();
    }
  };
  componentDidMount() {
    this.setState({
      isLoading: true
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'People / All users and contacts' }));

    this.setAdditionalItems()
      .catch(error => console.error('Unable to load user list filters', error))
      .then(() => this.setItems());
  }

  componentWillUnmount() {
    this.itemsRequestId += 1;
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      // Search, filtering, sorting and pagination update the existing table in place.
      // Replacing the whole screen with Loader here unmounts the inputs after every
      // debounced character and makes server-side search look like a page reload.
      this.setItems();
    }
  }

  setAdditionalItems() {
    const { user } = this.props;

    return BPromise.all([
      getAllUserTags(user),
      getSettingsUploadFiles(user),
      getSchoolSports(user, { limit: 3000, skip: 0, order: 'name ASC' } as any)
    ]).then(([tags, maxSizeUploadFile, sports]) => {
      this.setState({
        userTags: tags,
        maxSizeUploadFile: maxSizeUploadFile,
        sports
      });

      return true;
    });
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const parsedPage = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;
    const page = Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(FILTER_COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getSchoolUsersWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const requestId = ++this.itemsRequestId;
    this.setState({ isLoading: true });

    return searchSchoolUsers(user, serverQueryFilter)
      .then(({ items, total }) => {
        if (requestId !== this.itemsRequestId) return false;
        const lastPage = Math.max(FIRST_PAGE, Math.ceil(total / LIMIT));
        if (page > lastPage) {
          const nextSearch = { ...search };
          if (lastPage === FIRST_PAGE) delete nextSearch.page;
          else nextSearch.page = String(lastPage);
          history.replace({ pathname: history.location.pathname, search: stringify(nextSearch) });
          return false;
        }
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: false,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items,
          previewUser: this.state.previewUser
            ? items.find(item => item.id === this.state.previewUser.id) || null
            : null,
          total,
          basePath: history.location.pathname,
          isLoading: false
        });

        return true;
      })
      .catch(error => {
        if (requestId === this.itemsRequestId) this.setState({ isLoading: false });
        console.error('Unable to load school users', error);
        return false;
      });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const nextSelectedItems = [...selectedItems];

    items.forEach(item => {
      if (!selectedIds.has(item.id)) {
        nextSelectedItems.push(item);
      }
    });

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isSelectionMenuOpen: false
    });
  };

  onSelectAllClick = (): void => {
    this.setState({
      isSelectAllChecked: true,
      selectedItems: [],
      excludedSelectionIds: [],
      isSelectionMenuOpen: false
    });
  };

  resolveSelectedUsersForBulkAction = (callback: () => void): void => {
    const { isSelectAllChecked, excludedSelectionIds, filters } = this.state;

    if (!isSelectAllChecked) {
      callback();
      return;
    }

    this.setState({ isLoading: true });

    const user = this.props.user;
    const where = getSchoolUsersWhere(filters);

    getAllSchoolUsers(user, where)
      .then(users => {
        const excludedIds = new Set(excludedSelectionIds);
        const nextSelectedItems = users.filter(item => !excludedIds.has(item.id));

        this.setState(
          {
            selectedItems: nextSelectedItems,
            isLoading: false
          },
          callback
        );
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.error('Unable to resolve all selected users', error);
      });
  };

  getSelectedUsersCount = (): number =>
    this.state.isSelectAllChecked
      ? Math.max(0, this.state.total - this.state.excludedSelectionIds.length)
      : this.state.selectedItems.length;

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isSelectionMenuOpen: false
    });
  };
  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = FILTER_COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      filters: {},
      selectedItems: [],
      isSelectAllChecked: false,
      excludedSelectionIds: [],
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
      isColumnsMenuOpen: false
    });
  };

  onSendMessageClick = (): void => {
    this.resolveSelectedUsersForBulkAction(() => {
      this.props.history.push({
        pathname: '/generalMessages/create',
        state: {
          fromAllUsersList: true,
          users: this.state.selectedItems,
          returnTo: {
            pathname: this.state.basePath,
            search: this.props.location.search
          }
        }
      });
    });
  };

  onAccountSetupReminderClick = (): void => {
    this.resolveSelectedUsersForBulkAction(() => {
      const userIds = this.state.selectedItems.map(item => item.id);
      this.setState({
        isAccountSetupReminderModalOpen: true,
        isAccountSetupReminderLoading: true,
        accountSetupReminderPreview: null,
        accountSetupReminderError: '',
        accountSetupReminderSuccess: ''
      });
      previewAccountSetupReminders(this.props.user, userIds)
        .then(preview => this.setState({ accountSetupReminderPreview: preview, isAccountSetupReminderLoading: false }))
        .catch(error =>
          this.setState({
            isAccountSetupReminderLoading: false,
            accountSetupReminderError: propz.get(error, ['response', 'data', 'details', 'text'], 'Unable to check the selected users.')
          })
        );
    });
  };

  closeAccountSetupReminderModal = (): void => {
    if (this.state.isAccountSetupReminderSending) return;
    this.setState({ isAccountSetupReminderModalOpen: false, accountSetupReminderError: '', accountSetupReminderSuccess: '' });
  };

  sendAccountSetupReminder = (): void => {
    const userIds = this.state.selectedItems.map(item => item.id);
    this.setState({ isAccountSetupReminderSending: true, accountSetupReminderError: '' });
    sendAccountSetupReminders(this.props.user, userIds, this.state.accountSetupReminderLifetimeHours)
      .then(result => {
        this.setState({
          isAccountSetupReminderSending: false,
          selectedItems: [],
          isSelectAllChecked: false,
          excludedSelectionIds: [],
          accountSetupReminderSuccess: `${result.queuedCount} account setup reminder${result.queuedCount === 1 ? '' : 's'} queued for email delivery.`
        });
      })
      .catch(error =>
        this.setState({
          isAccountSetupReminderSending: false,
          accountSetupReminderError: propz.get(error, ['response', 'data', 'details', 'text'], 'Unable to send account setup reminders.')
        })
      );
  };

  renderAccountSetupReminderModal(): React.ReactNode {
    const {
      isAccountSetupReminderModalOpen,
      isAccountSetupReminderLoading,
      isAccountSetupReminderSending,
      accountSetupReminderPreview: preview,
      accountSetupReminderLifetimeHours,
      accountSetupReminderError
    } = this.state;
    const { accountSetupReminderSuccess } = this.state;
    const audienceCopy = preview
      ? preview.audience === 'MIXED'
        ? 'The email wording will adapt for students, parents and staff.'
        : `The email will use the ${preview.audience.toLowerCase()} account setup wording.`
      : '';
    return (
      <SimpleModal
        isOpen={isAccountSetupReminderModalOpen}
        title={accountSetupReminderSuccess ? 'Account setup reminders queued' : 'Send account setup reminder'}
        onCloseClick={this.closeAccountSetupReminderModal}
        showFooter={false}
        customClass="accountSetupReminderModal"
        isBodyBold={false}
      >
        <div className="accountSetupReminder">
          {accountSetupReminderSuccess ? (
            <>
              <div className="accountSetupReminder__success">
                <div className="accountSetupReminder__successIcon" aria-hidden="true">
                  <FontAwesomeIcon icon={faCheck} />
                </div>
                <span className="accountSetupReminder__successEyebrow">Successfully queued</span>
                <strong>Account setup reminders are on their way</strong>
                <p>{accountSetupReminderSuccess}</p>
                <small>Each recipient will receive a secure, one-time link to create their own password.</small>
              </div>
              <div className="accountSetupReminder__actions">
                <button type="button" className="people-btn people-btn--primary" onClick={this.closeAccountSetupReminderModal}>Done</button>
              </div>
            </>
          ) : isAccountSetupReminderLoading ? (
            <Loader />
          ) : (
            <>
              {preview && (
                <>
                  <div className="accountSetupReminder__summary">
                    <strong>{preview.eligibleCount} of {preview.selectedCount} can receive this reminder</strong>
                    <span>{audienceCopy}</span>
                  </div>
                  {preview.skippedCount > 0 && (
                    <div className="accountSetupReminder__notice">
                      {preview.skippedCount} skipped: {preview.skipped.alreadySetUp} already set up, {preview.skipped.noEmail} without email, {preview.skipped.inactive} inactive, {preview.skipped.noSchoolRole} without an active school role.
                    </div>
                  )}
                  <label className="accountSetupReminder__field">
                    <span>Setup link valid for</span>
                    <select
                      value={accountSetupReminderLifetimeHours}
                      onChange={event => this.setState({ accountSetupReminderLifetimeHours: Number(event.target.value) as any })}
                    >
                      <option value={24}>24 hours</option>
                      <option value={48}>48 hours</option>
                      <option value={72}>3 days</option>
                      <option value={168}>7 days</option>
                    </select>
                    <small>The secure link works once. Sending a new reminder replaces any previous setup link.</small>
                  </label>
                </>
              )}
              {accountSetupReminderError && <div className="accountSetupReminder__error">{accountSetupReminderError}</div>}
              <div className="accountSetupReminder__actions">
                <button type="button" className="people-btn people-btn--secondary" onClick={this.closeAccountSetupReminderModal}>Cancel</button>
                <button
                  type="button"
                  className="people-btn people-btn--primary"
                  disabled={!preview || preview.eligibleCount === 0 || isAccountSetupReminderSending}
                  onClick={this.sendAccountSetupReminder}
                >
                  {isAccountSetupReminderSending ? 'Sending…' : `Send reminder${preview && preview.eligibleCount !== 1 ? 's' : ''}`}
                </button>
              </div>
            </>
          )}
        </div>
      </SimpleModal>
    );
  }

  onUserTagAssignClick = (): void => {
    this.resolveSelectedUsersForBulkAction(() => {
      this.setState({
        isUserTagModalOpen: true
      });
    });
  };

  onUserTagDeleteClick = (): void => {
    this.resolveSelectedUsersForBulkAction(() => {
      this.setState({
        isUserTagDeleteModalOpen: true
      });
    });
  };

  onUserTagChange = (event): void => {
    const value = event.target.value;

    this.setState({
      selectedUserTagId: value
    });
  };

  onUserTagAssignModalCloseClick = (): void => {
    this.setState({
      isUserTagModalOpen: false,
      selectedUserTagId: ''
    });
  };

  onUserTagSaveClick = (selectedTagIds: string[] = []): void => {
    const tagIds = selectedTagIds.length ? selectedTagIds : [this.state.selectedUserTagId].filter(Boolean);
    const user = this.props.user;

    this.setState({
      isLoading: true
    });

    if (tagIds.length === 0) {
      this.setState({
        isUserTagModalOpen: false,
        selectedUserTagId: ''
      });
      console.error('Can not assign user tag id');
    } else {
      const selectedItems = this.state.selectedItems;
      updateUserTagsInBulk(
        user,
        selectedItems.map(item => item.id),
        tagIds,
        'ADD'
      )
        .then(() => {
          this.setState({
            isUserTagModalOpen: false,
            selectedUserTagId: '',
            selectedItems: [],
            isSelectAllChecked: false,
            excludedSelectionIds: []
          });
          this.setItems();
        })
        .catch(error => {
          console.error('Can not assign user tags', error);
          this.setState({ isLoading: false });
        });
    }
  };

  renderUserTagAssignModal(): React.ReactNode {
    const { userTags, selectedUserTagId, isUserTagModalOpen, selectedItems } = this.state;
    const tagIdsByUser = selectedItems.map(item => this.getSafeUserTags(item).map(tag => tag.id));
    const excludedUserTagIds = Array.from(
      new Set(tagIdsByUser.reduce<string[]>((result, tagIds) => [...result, ...tagIds], []))
    );

    return (
      <UserTagAssignModal
        modalTitle={'Assign User Tag'}
        userTags={userTags}
        selectedUserTagId={selectedUserTagId}
        excludedUserTagIds={excludedUserTagIds}
        selectedStudents={selectedItems}
        onUserTagChange={this.onUserTagChange}
        onCloseClick={this.onUserTagAssignModalCloseClick}
        isOpen={isUserTagModalOpen}
        onCreateTag={this.onCreateUserTagFromAssignModal}
        onSaveClick={this.onUserTagSaveClick}
      />
    );
  }

  onCreateUserTagFromAssignModal = (tagName: string, color: string): Promise<Tag> => {
    return createUserTag(this.props.user, { tagName, color }).then((createdTag: Tag) => {
      this.setState(prevState => ({
        userTags: [...prevState.userTags, createdTag]
      }));
      return createdTag;
    });
  };

  getUserTags(): Tag[] {
    const { selectedItems, items } = this.state;

    const tags = Lazy(selectedItems)
      .map(selectedItem => {
        const selectedItemId = selectedItem.id;
        const user = items.find(userState => userState.id === selectedItemId);

        if (typeof user !== 'undefined') {
          return user.permissions[0].tags;
        } else {
          return [];
        }
      })
      .filter(tagList => tagList.length > 0)
      .flatten()
      .uniq('id')
      .toArray();

    return tags;
  }

  onUserTagDeleteModalCloseClick = (): void => {
    this.setState({
      isUserTagDeleteModalOpen: false,
      selectedUserTagId: ''
    });
  };

  onUserTagDelete = (selectedTagIds?: string[]): void => {
    const userTagIds =
      selectedTagIds && selectedTagIds.length ? selectedTagIds : [this.state.selectedUserTagId].filter(Boolean);
    const user = this.props.user;

    this.setState({
      isLoading: true
    });

    if (userTagIds.length === 0) {
      this.setState({
        isUserTagDeleteModalOpen: false,
        selectedUserTagId: ''
      });
      console.error('Can not assign user tag id');
    } else {
      const selectedItems = this.state.selectedItems;

      updateUserTagsInBulk(
        user,
        selectedItems.map(item => item.id),
        userTagIds,
        'REMOVE'
      )
        .then(() => {
          this.setState({
            isUserTagDeleteModalOpen: false,
            selectedUserTagId: '',
            selectedItems: [],
            isSelectAllChecked: false,
            excludedSelectionIds: []
          });
          this.setItems();
        })
        .catch(error => {
          console.error('Can not remove user tags', error);
          this.setState({ isLoading: false });
        });
    }
  };

  renderUserTagDeleteModal(): React.ReactNode {
    const { selectedUserTagId, isUserTagDeleteModalOpen } = this.state;

    return (
      <UserTagDeleteModal
        modalTitle={'Delete User Tag'}
        userTags={this.getUserTags()}
        selectedUserTagId={selectedUserTagId}
        onUserTagChange={this.onUserTagChange}
        onCloseClick={this.onUserTagDeleteModalCloseClick}
        isOpen={isUserTagDeleteModalOpen}
        onDeleteClick={this.onUserTagDelete}
      />
    );
  }

  onMessageSubmitClick = message => {
    const { history } = this.props;

    history.push({
      pathname: '/generalMessages',
      state: { message: message }
    });
  };

  onCloseMessageWizardClick = (): void => {
    this.setState({
      isMessageModalOpen: false
    });
  };

  onAddUserRoleClick = (): void => {
    this.setState({
      isAddRoleFormOpen: true,
      addRoleInitialPreset: ''
    });
  };

  onCloseAddRoleFormModalClick = (): void => {
    this.setState({
      isAddRoleFormOpen: false,
      addRoleInitialPreset: ''
    });
  };

  onSubmitUserAddRoleForm = data => {
    const { user } = this.props;
    this.setState({
      isLoading: true
    });

    const selectedItem = { ...this.state.selectedItems[0] };
    const { activeSchoolId } = user;

    const { priority, ...rest } = data;

    let dataCopy = {
      ...rest,
      schoolId: activeSchoolId,
      priority: Number(priority)
    };

    if (data.preset !== ROLE.COACH && data.preset !== ROLE.TEACHER) {
      delete dataCopy.sportIds;
      delete dataCopy.sports;
    }

    if (data.preset !== ROLE.PARENT) {
      delete dataCopy.studentId;
      delete dataCopy.priority;
      delete dataCopy.priority;
    }

    postUserPermission(user, selectedItem.id, dataCopy).then(item => {
      selectedItem.permissions.push({ tags: [], ...item });

      this.setState({
        isAddRoleFormOpen: false,
        addRoleInitialPreset: '',
        selectedItems: [selectedItem],
        previewUser:
          this.state.previewUser && this.state.previewUser.id === selectedItem.id
            ? selectedItem
            : this.state.previewUser
      });
      this.setItems();
    });
  };

  onRevokeUserRoleClick = (): void => {
    const { selectedItems } = this.state;
    const selectedItem = selectedItems[0];
    const userPermissions = this.getManageablePermissions(selectedItem.permissions);
    if (userPermissions.length === 0) {
      return;
    }
    const isOnePermission = userPermissions.length === 1;

    if (isOnePermission) {
      this.setState({
        revokePermissions: userPermissions,
        isConfirmRevokeRoleModalOpen: true
      });
    } else {
      this.setState({
        isRevokeRoleFormOpen: true
      });
    }
  };

  getManageablePermissions = (permissions: SchoolUserPermission[] = []): SchoolUserPermission[] => {
    if (this.props.user.activeRole !== ROLE.MANAGER) {
      return permissions;
    }

    return permissions.filter(permission => permission.preset !== ROLE.ADMIN && permission.preset !== ROLE.MANAGER);
  };

  onRevokeRoleModalClick = (): void => {
    const { revokePermissions, selectedItems } = this.state;
    const { user } = this.props;
    const selectedItem = selectedItems[0];
    const userId = propz.get(selectedItem, ['id'], '');

    let promises = [];
    revokePermissions.forEach(permission => {
      promises.push(deleteDataToPermission(user, userId, permission.id));
    });

    this.setState({
      isLoading: true
    });
    BPromise.all(promises).then(res => {
      const revokedIds = new Set(revokePermissions.map(permission => permission.id));
      this.setState(prevState => {
        const updateUser = (item: SchoolUser): SchoolUser => ({
          ...item,
          permissions: propz.get(item, ['permissions'], []).filter(permission => !revokedIds.has(permission.id))
        });
        const previewUser = prevState.previewUser ? updateUser(prevState.previewUser) : null;
        return {
          selectedItems: [],
          previewUser: previewUser && previewUser.permissions.length > 0 ? previewUser : null,
          items: prevState.items.map(item => (item.id === userId ? updateUser(item) : item)),
          revokePermissions: [],
          isConfirmRevokeRoleModalOpen: false,
          isLoading: false
        };
      });
      this.setItems();
    });
  };

  onCloseConfirmRevokeRoleModalClick = (): void => {
    this.setState({
      isConfirmRevokeRoleModalOpen: false
    });
  };

  onCloseRevokeRoleFormModalClick = (): void => {
    this.setState({
      isRevokeRoleFormOpen: false
    });
  };

  onSubmitUserRevokeRoleForm = (revokePermissions: SchoolUserPermission[]): void => {
    const isExistRevokePermissions = revokePermissions.length > 0;
    if (isExistRevokePermissions) {
      this.setState({
        revokePermissions: revokePermissions,
        isRevokeRoleFormOpen: false,
        isConfirmRevokeRoleModalOpen: true
      });
    } else {
      this.setState({
        isRevokeRoleFormOpen: false
      });
    }
  };

  renderRevokeRoleFormModal(): React.ReactNode {
    const { isRevokeRoleFormOpen, selectedItems } = this.state;
    const selectedItem = selectedItems[0];
    const userPermissions = this.getManageablePermissions(propz.get(selectedItem, ['permissions'], []));
    return (
      <SimpleModal
        customClass="peopleRoleActionModal"
        bodyClassName="peopleRoleActionModal__body"
        zIndex={2147483100}
        isOpen={isRevokeRoleFormOpen}
        title="Revoke role"
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.onCloseRevokeRoleFormModalClick}
      >
        <UserRevokeRoleForm
          userPermissions={userPermissions}
          onSubmit={this.onSubmitUserRevokeRoleForm}
          onCloseClick={this.onCloseRevokeRoleFormModalClick}
          affectedUsersCount={selectedItems.length}
        />
      </SimpleModal>
    );
  }

  renderConfirmRevokeRoleModalOpen(): React.ReactNode {
    const { isConfirmRevokeRoleModalOpen, revokePermissions, selectedItems } = this.state;
    const roleNames = revokePermissions.map(permission => ROLE_SERVER_TO_CLIENT_MAPPING[permission.preset]).join(', ');
    const selectedUserPermissions = propz.get(selectedItems[0], ['permissions'], []);
    const isOnlyRole = selectedUserPermissions.length === 1 && revokePermissions.length === 1;

    return (
      <SimpleModal
        isOpen={isConfirmRevokeRoleModalOpen}
        title="Revoke role?"
        customClass="peopleDangerModal"
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.onCloseConfirmRevokeRoleModalClick}
      >
        <div className="peopleDangerModal__content">
          <div className="peopleDangerModal__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
            </svg>
          </div>
          <div className="peopleDangerModal__copy">
            <strong>
              The selected {revokePermissions.length === 1 ? 'role' : 'roles'} “{roleNames}” will be revoked.
            </strong>
            <p>This changes the user's access to your school immediately.</p>
          </div>
          {isOnlyRole ? (
            <div className="peopleDangerModal__warning">
              <strong>This is the user's only role.</strong>
              <p>
                After it is revoked, you will no longer see this user in your school's user list. To regain access, they
                will need to request a role again from their profile.
              </p>
            </div>
          ) : null}
          <div className="peopleDangerModal__actions">
            <button type="button" className="sit-btn sit-btn--ghost" onClick={this.onCloseConfirmRevokeRoleModalClick}>
              Cancel
            </button>
            <button type="button" className="sit-btn sit-btn--danger" onClick={this.onRevokeRoleModalClick}>
              Revoke role
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderAddRoleFormModal(): React.ReactNode {
    const { isAddRoleFormOpen, selectedItems, addRoleInitialPreset } = this.state;
    const { user } = this.props;
    const selectedItem = selectedItems[0];
    const userPermissions = propz.get(selectedItem, ['permissions'], []);
    return (
      <SimpleModal
        customClass="peopleRoleActionModal"
        bodyClassName="peopleRoleActionModal__body"
        isOpen={isAddRoleFormOpen}
        title={addRoleInitialPreset === ROLE.PARENT ? 'Add child to parent' : 'Add role'}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.onCloseAddRoleFormModalClick}
      >
        <UserAddRoleForm
          user={user}
          userPermissions={userPermissions}
          onSubmit={this.onSubmitUserAddRoleForm}
          onCloseClick={this.onCloseAddRoleFormModalClick}
          initialPreset={addRoleInitialPreset}
          affectedUsersCount={selectedItems.length}
        />
      </SimpleModal>
    );
  }

  renderGMWizard(): React.ReactNode {
    const { user } = this.props;
    const { selectedItems, isMessageModalOpen, maxSizeUploadFile } = this.state;
    const selectedUsers = selectedItems.slice();

    if (!isMessageModalOpen) {
      return null;
    }

    let isContainStaff = undefined;
    let isContainStudents = undefined;
    let isContainParents = undefined;

    selectedUsers.forEach(user => {
      user.permissions.forEach(permission => {
        const preset = permission.preset;

        const isAdmin = preset === ROLE.ADMIN;
        const isManager = preset === ROLE.MANAGER;
        const isCoach = preset === ROLE.COACH;
        const isGovernor = preset === ROLE.GOVERNOR;
        const isTeacher = preset === ROLE.TEACHER;
        const isStudent = preset === ROLE.STUDENT;
        const isParent = preset === ROLE.PARENT;

        if (isAdmin || isManager || isCoach || isGovernor || isTeacher) {
          isContainStaff = true;
        }
        if (isStudent) {
          isContainStudents = true;
        }
        if (isParent) {
          isContainParents = true;
        }
      });
    });

    return (
      <GeneralMessageWizzard
        user={user}
        onMessageSubmit={this.onMessageSubmitClick}
        onCancelClick={this.onCloseMessageWizardClick}
        isOpen={isMessageModalOpen}
        schoolStaff={selectedItems}
        sendToParents={isContainParents}
        sendToStudents={isContainStudents}
        sendToStaff={isContainStaff}
        maxSizeUploadFile={maxSizeUploadFile}
        fullScreen={true}
      />
    );
  }

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId, activeSchool } = user;
    const { selectedItems } = this.state;
    const schoolUser = selectedItems[0];
    const schoolUserId = propz.get(schoolUser, ['id'], '');

    const { dateTo, dateFrom, isShowZero, isShowNonZero } = data;

    let modData;
    let formsUniq;
    let ages: number[];

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.USER_ACTIVITY_DETAILS:
        this.setState({
          isUserActivityDetailsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        const formattedDateTo = moment(dateTo).format('YYYY-MM-DD HH:mm:ss');
        const formattedDateFrom = moment(dateFrom).format('YYYY-MM-DD HH:mm:ss');

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            schoolUserId,
            dateFrom: formattedDateFrom,
            dateTo: formattedDateTo
          }
        };
        break;
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.STUDENT_ACTIVITY:
        this.setState({
          isStudentActivityReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            showZero: isShowZero,
            showNonZero: isShowNonZero
          }
        };
        break;
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PARENT_ACTIVITY:
        this.setState({
          isParentActivityReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            showZero: isShowZero,
            showNonZero: isShowNonZero
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const { reportType } = data;

          this.setState({
            isLoading: false
          });

          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}`;
          window.open(url);
        } else {
          this.setState({
            isLoading: false,
            errorMessage: 'No read report',
            isErrorModalOpen: true
          });
        }
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  openUserActivityDetailsReportForm = () => {
    this.resolveSelectedUsersForBulkAction(() => {
      this.setState({
        isUserActivityDetailsReportModalOpen: true
      });
    });
  };

  openReportsSelectionModal = (): void => {
    const selectedCount = this.getSelectedUsersCount();
    if (selectedCount > 1) {
      return;
    }
    this.setState({ isReportsSelectionModalOpen: true });
  };

  closeReportsSelectionModal = (): void => {
    this.setState({ isReportsSelectionModalOpen: false });
  };

  selectReportOption = (onSelect: () => void): void => {
    this.setState({ isReportsSelectionModalOpen: false }, onSelect);
  };

  renderReportsSelectionModal(): React.ReactNode {
    const { isReportsSelectionModalOpen } = this.state;
    const selectedCount = this.getSelectedUsersCount();
    const reports =
      selectedCount === 1
        ? [
            {
              name: 'User activity details',
              description: 'Activity for one selected user over a chosen period.',
              formats: 'Excel',
              action: this.openUserActivityDetailsReportForm
            }
          ]
        : [
            {
              name: 'Students activity summary',
              description: 'Student platform activity for a chosen period.',
              formats: 'Excel',
              action: this.openStudentActivityReportForm
            },
            {
              name: 'Parents activity summary',
              description: 'Parent platform activity for a chosen period.',
              formats: 'Excel',
              action: this.openParentActivityReportForm
            }
          ];

    return (
      <SimpleModal
        customClass="eEventPrintModal"
        isOpen={isReportsSelectionModalOpen}
        title="Printed forms & reports"
        onCloseClick={this.closeReportsSelectionModal}
        showFooter={false}
        isBodyBold={false}
      >
        <div className="eEventPrintModal__intro">
          Choose a report. You can configure its contents and format on the next step.
        </div>
        <section className="eEventPrintModal__group">
          <h3 className="eEventPrintModal__groupTitle">People activity</h3>
          <div className="eEventPrintModal__list">
            {reports.map(report => (
              <button
                type="button"
                className="eEventPrintModal__item"
                key={report.name}
                onClick={() => this.selectReportOption(report.action)}
              >
                <span className="eEventPrintModal__itemIcon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" />
                  </svg>
                </span>
                <span className="eEventPrintModal__itemCopy">
                  <span className="eEventPrintModal__itemHeading">
                    <span>{report.name}</span>
                    <span className="eEventPrintModal__format">{report.formats}</span>
                  </span>
                  <span className="eEventPrintModal__itemDescription">{report.description}</span>
                </span>
                <span className="eEventPrintModal__arrow" aria-hidden="true">
                  ›
                </span>
              </button>
            ))}
          </div>
        </section>
      </SimpleModal>
    );
  }

  closeUserActivityDetailsReportForm = () => {
    this.setState({
      isUserActivityDetailsReportModalOpen: false
    });
  };

  openStudentActivityReportForm = () => {
    this.setState({
      isStudentActivityReportModalOpen: true
    });
  };

  closeStudentActivityReportForm = () => {
    this.setState({
      isStudentActivityReportModalOpen: false
    });
  };

  openParentActivityReportForm = () => {
    this.setState({
      isParentActivityReportModalOpen: true
    });
  };

  closeParentActivityReportForm = () => {
    this.setState({
      isParentActivityReportModalOpen: false
    });
  };

  renderReportModalTitle = (title: string, category: string) => (
    <div className="eReportModalTitle">
      <span className="eReportModalTitle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
        </svg>
      </span>
      <span className="eReportModalTitle__copy">
        <span className="eReportModalTitle__name">{title}</span>
        <span className="eReportModalTitle__category">{category}</span>
      </span>
    </div>
  );

  renderUserActivityDetailsReportFormModal() {
    const { isUserActivityDetailsReportModalOpen, selectedItems } = this.state;
    const user = selectedItems[0];
    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isUserActivityDetailsReportModalOpen}
        title={this.renderReportModalTitle('User activity details', 'Activity report')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeUserActivityDetailsReportForm}
      >
        <UserActivityDetailsReportForm
          onCloseClick={this.closeUserActivityDetailsReportForm}
          onSubmit={this.onSubmitReportForm}
          user={user}
        />
      </SimpleModal>
    );
  }

  renderStudentActivityReportFormModal() {
    const { isStudentActivityReportModalOpen } = this.state;
    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isStudentActivityReportModalOpen}
        title={this.renderReportModalTitle('Students activity summary', 'Activity report')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeStudentActivityReportForm}
      >
        <StudentActivityReportForm
          onCloseClick={this.closeStudentActivityReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  renderParentActivityReportFormModal() {
    const { isParentActivityReportModalOpen } = this.state;
    return (
      <SimpleModal
        customClass="eEventReportParametersModal"
        bodyClassName="eEventReportParametersModal__body"
        isOpen={isParentActivityReportModalOpen}
        title={this.renderReportModalTitle('Parents activity summary', 'Activity report')}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.closeParentActivityReportForm}
      >
        <ParentActivityReportForm
          onCloseClick={this.closeParentActivityReportForm}
          onSubmit={this.onSubmitReportForm}
        />
      </SimpleModal>
    );
  }

  getUserFullName(user: SchoolUser): string {
    return `${propz.get(user, ['firstName'], '')} ${propz.get(user, ['lastName'], '')}`.trim();
  }

  getUserInitials(user: SchoolUser): string {
    return `${propz.get(user, ['firstName'], '?').charAt(0)}${propz.get(user, ['lastName'], '').charAt(0)}`;
  }

  renderUserAvatar(user: SchoolUser, isLarge: boolean = false): React.ReactNode {
    const avatar = propz.get(user, ['avatar'], '');
    return (
      <span className={isLarge ? 'people-avatar people-avatar--lg' : 'people-avatar'}>
        {this.getUserInitials(user)}
        {avatar && <img src={avatar} alt="" onError={event => (event.currentTarget.style.display = 'none')} />}
      </span>
    );
  }

  getUserRoleNames(user: SchoolUser): string[] {
    return Lazy(propz.get(user, ['permissions'], []))
      .map(permission => permission.preset)
      .uniq()
      .toArray() as string[];
  }

  renderRoleChips(user: SchoolUser): React.ReactNode {
    const roles = this.getUserRoleNames(user);

    if (roles.length === 0) {
      return <span className="people-flag people-flag--off">-</span>;
    }

    return (
      <span className="users-chipList">
        {roles.slice(0, 3).map(role => (
          <span key={role} className="users-roleChip">
            {ROLE_SERVER_TO_CLIENT_MAPPING[role] || role}
          </span>
        ))}
        {roles.length > 3 && <span className="users-chipMore">+{roles.length - 3} more</span>}
      </span>
    );
  }

  getSafeUserTags(user: SchoolUser): Tag[] {
    return Lazy(propz.get(user, ['permissions'], []))
      .map(permission => propz.get(permission, ['tags'], []))
      .flatten()
      .filter(tag => typeof tag !== 'undefined' && tag !== null)
      .uniq('id')
      .toArray() as Tag[];
  }

  renderUserTags(user: SchoolUser, showAll: boolean = false): React.ReactNode {
    const rawTags = this.getSafeUserTags(user);

    if (rawTags.length === 0) {
      return <span className="people-flag people-flag--off">-</span>;
    }

    return (
      <span className="people-tags">
        {(showAll ? rawTags : rawTags.slice(0, 2)).map(tag => {
          const color = getUserTagColor(tag);
          return (
            <span key={tag.id || tag.tagName} style={{ '--tag-color': color } as React.CSSProperties}>
              <i />
              {tag.tagName}
            </span>
          );
        })}
        {!showAll && rawTags.length > 2 && <span className="users-chipMore">+{rawTags.length - 2} more</span>}
      </span>
    );
  }

  renderStatus(status: string): React.ReactNode {
    const isActive = String(status || '').toLowerCase() === 'active';
    return (
      <span className={`users-status ${isActive ? 'users-status--active' : ''}`}>
        {getUserStatus({ status } as any) || status || '-'}
      </span>
    );
  }

  renderUsersTable(): React.ReactNode {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      isSelectAllChecked,
      excludedSelectionIds,
      previewUser,
      filters,
      currentPage,
      total,
      userTags,
      hiddenUserColumnKeys,
      isColumnsMenuOpen,
      isSelectionMenuOpen
    } = this.state;

    const hiddenColumns = new Set(hiddenUserColumnKeys);
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const excludedIds = new Set(excludedSelectionIds);
    const previewUserId = previewUser ? previewUser.id : '';
    const allPageSelected = isSelectAllChecked
      ? items.length > 0 && items.every(item => !excludedIds.has(item.id))
      : items.length > 0 && items.every(item => selectedIds.has(item.id));
    const selectedCount = isSelectAllChecked ? Math.max(0, total - excludedSelectionIds.length) : selectedItems.length;
    const canRevokeSelectedUser =
      selectedItems.length === 1 &&
      this.getManageablePermissions(propz.get(selectedItems[0], ['permissions'], [])).length > 0;
    const filterOptions = {
      role: getSelectOptionForRole(),
      userStatus: getSelectOptionForUserStatus(),
      tag: getSelectOptionForTag(userTags),
      loggedIn: [
        { text: 'Yes', value: 'YES' },
        { text: 'No', value: 'NO' }
      ]
    };

    const lockedColumns = new Set(['firstName', 'lastName']);
    const visibleColumns = COLUMNS.filter(
      column => lockedColumns.has(column.field) || !hiddenColumns.has(column.field)
    );

    const getFilterValue = (field: string): string => {
      const value = filters[field];
      if (Array.isArray(value)) {
        return value[0] || '';
      }
      if (value && typeof value === 'object') {
        return '';
      }
      return typeof value === 'undefined' ? '' : String(value);
    };

    const renderSelect = (field: string, label: string, options: any[], placeholder: string): React.ReactNode => (
      <label className="people-filter__field">
        <span>{label}</span>
        <select
          className={
            getFilterValue(field) === ''
              ? 'users-filter__select users-filter__select--placeholder'
              : 'users-filter__select'
          }
          value={getFilterValue(field)}
          onChange={event => this.onModernFilterChange(field, event.target.value)}
          onKeyDown={this.onModernFilterKeyDown}
        >
          <option value="">{placeholder}</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.text || option.label || option.value}
            </option>
          ))}
        </select>
      </label>
    );

    const renderMultiSelect = (
      field: 'role' | 'userStatus' | 'tag',
      label: string,
      options: any[]
    ): React.ReactNode => {
      const selected = Array.isArray(filters[field]) ? filters[field] : filters[field] ? [filters[field]] : [];
      const tagById = new Map(userTags.map(tag => [String(tag.id), tag]));
      return (
        <PeopleFilterChipSelect
          label={label}
          selected={selected.map(String)}
          collapsedLimit={field === 'tag' ? 6 : undefined}
          options={options.map(option => ({
            value: String(option.value),
            label: String(option.text || option.label || option.value),
            color: field === 'tag' ? getUserTagColor(tagById.get(String(option.value))) : undefined
          }))}
          onToggle={value => this.onModernMultiFilterToggle(field, value)}
        />
      );
    };

    const renderSearchField = (field: string, label: string, placeholder: string): React.ReactNode => (
      <label className="people-search__field">
        <span>{label}</span>
        <input
          value={getFilterValue(field)}
          onChange={event => this.onModernFilterChange(field, event.target.value)}
          onKeyDown={this.onModernFilterKeyDown}
          placeholder={placeholder}
        />
      </label>
    );

    const renderFilterText = (field: 'email' | 'phone', label: string, placeholder: string): React.ReactNode => (
      <label className="people-filter__field">
        <span>{label}</span>
        <input
          value={getFilterValue(field)}
          placeholder={placeholder}
          onChange={event => this.onModernFilterChange(field, event.target.value)}
          onKeyDown={this.onModernFilterKeyDown}
        />
      </label>
    );

    const getCellValue = (user: SchoolUser, column: ColumnDefinition): React.ReactNode => {
      const field = column.field;

      switch (field) {
        case 'firstName':
          return (
            <div className="people-person">
              {this.renderUserAvatar(user)}
              <span className="people-person__name">{propz.get(user, ['firstName'], '')}</span>
            </div>
          );
        case 'lastName':
          return <span className="people-strong">{propz.get(user, ['lastName'], '')}</span>;
        case 'email':
          return <span className="people-mutedText">{getEmailOrMisEmail(user) || '-'}</span>;
        case 'phone':
          return <span className="people-mutedText">{getPhoneOrMisPhone(user) || '-'}</span>;
        case 'role':
          return this.renderRoleChips(user);
        case 'userStatus':
          return this.renderStatus(propz.get(user, ['status'], ''));
        case 'tag':
          return this.renderUserTags(user);
        case 'loggedIn':
          return user.lastLoginAt ? 'Yes' : 'No';
        case 'lastLoginAt':
          return user.lastLoginAt ? moment(user.lastLoginAt).format('DD MMM YYYY, HH:mm') : '—';
        default:
          const accessor = (column as any).accessor;
          if (typeof accessor === 'function') {
            return accessor(user);
          }
          if (Array.isArray(accessor)) {
            return propz.get(user, accessor, '-') || '-';
          }
          return propz.get(user, [field], '-') || '-';
      }
    };

    const toggleAllOnPage = (): void => {
      if (allPageSelected) {
        const pageIds = new Set(items.map(item => item.id));
        if (isSelectAllChecked) {
          this.setState({
            excludedSelectionIds: Array.from(new Set([...excludedSelectionIds, ...Array.from(pageIds)])),
            isSelectionMenuOpen: false
          });
          return;
        }
        this.setState({
          selectedItems: selectedItems.filter(item => !pageIds.has(item.id)),
          isSelectAllChecked: false,
          isSelectionMenuOpen: false
        });
      } else {
        if (isSelectAllChecked) {
          this.setState({
            excludedSelectionIds: excludedSelectionIds.filter(id => !items.some(item => item.id === id)),
            isSelectionMenuOpen: false
          });
          return;
        }
        const next = [...selectedItems];
        items.forEach(item => {
          if (!selectedIds.has(item.id)) {
            next.push(item);
          }
        });
        this.setState({ selectedItems: next, isSelectAllChecked: false, isSelectionMenuOpen: false });
      }
    };

    return (
      <div className="people-screen users-modernScreen schoolPeopleListCard">
        <div className="people-toolbar">
          <div className="people-toolbar__heading">
            <div className="people-search people-search--name users-toolbarSearch">
              {renderSearchField('nameSearch', 'Name', 'Search by first or last name')}
            </div>
            <button
              type="button"
              className={`people-btn people-btn--secondary people-btn--iconLeft people-filterBtn ${
                isShowFilter ? 'people-btn--on' : ''
              }`}
              onClick={this.onTableFilterClick}
            >
              <span className="people-icon people-icon--filter" />
              Filters
              {countActivePeopleFilters(filters) > 0 ? (
                <span className="people-btn__badge">{countActivePeopleFilters(filters)}</span>
              ) : null}
            </button>
            <div className="people-columns">
              <button
                type="button"
                className="people-btn people-btn--secondary people-btn--iconLeft"
                onClick={() => this.setState({ isColumnsMenuOpen: !isColumnsMenuOpen })}
              >
                <span className="people-icon people-icon--columns" />
                Columns <span className="people-btn__badge">{visibleColumns.length}</span>
              </button>
              {isColumnsMenuOpen && (
                <div className="people-columns__menu">
                  <div className="people-columns__head">
                    <span>Show / hide columns</span>
                    <button type="button" onClick={this.resetUserColumns}>
                      Reset
                    </button>
                  </div>
                  {COLUMNS.map(column => {
                    const isLocked = lockedColumns.has(column.field);
                    const isVisible = isLocked || !hiddenColumns.has(column.field);
                    return (
                      <label
                        key={column.field}
                        className={`people-columns__item ${isLocked ? 'people-columns__item--locked' : ''}`}
                      >
                        <input
                          type="checkbox"
                          checked={isVisible}
                          disabled={isLocked}
                          onChange={() => this.toggleUserColumn(column.field)}
                        />
                        <span>{column.text}</span>
                      </label>
                    );
                  })}
                </div>
              )}
            </div>
            {selectedCount === 0 && (
              <button
                type="button"
                className="people-btn people-btn--secondary people-btn--iconLeft people-toolbarReport"
                onClick={this.openReportsSelectionModal}
              >
                <span className="people-icon people-icon--reports" /> Reports
              </button>
            )}
          </div>
        </div>

        {isShowFilter && (
          <form
            className="people-filter users-filter"
            onSubmit={event => {
              event.preventDefault();
              this.onApplyFilterClick();
            }}
          >
            <div className="people-filter__header">
              <strong>Filters</strong>
              <button
                type="button"
                onClick={() => {
                  this.setState({ isShowFilter: false });
                  this.setItems();
                }}
                aria-label="Close filters"
              >
                ×
              </button>
            </div>
            <div className="people-filter__body">
              {renderFilterText('email', 'Email', 'Search by email')}
              {renderFilterText('phone', 'Phone', 'Search by phone')}
              {renderMultiSelect('role', 'Roles', filterOptions.role)}
              {renderMultiSelect('userStatus', 'Status', filterOptions.userStatus)}
              {renderMultiSelect('tag', 'Tags', filterOptions.tag)}
              {renderSelect('loggedIn', 'Logged in', filterOptions.loggedIn, 'Any')}
              <label className="people-filter__field">
                <span>Last login from</span>
                <input type="date" value={propz.get(filters, ['lastLoginAt', 'from'], '')} onChange={event => this.onTableFilterChange(event, 'lastLoginAt', DATE_INTERVAL.FROM)} />
              </label>
              <label className="people-filter__field">
                <span>Last login to</span>
                <input type="date" value={propz.get(filters, ['lastLoginAt', 'to'], '')} onChange={event => this.onTableFilterChange(event, 'lastLoginAt', DATE_INTERVAL.TO)} />
              </label>
            </div>
            <div className="people-filter__actions">
              <button type="button" className="people-btn people-btn--ghost" onClick={this.onClearFilterClick}>
                Clear all
              </button>
              <div>
                <button
                  type="button"
                  className="people-btn people-btn--secondary"
                  onClick={() => {
                    this.setState({ isShowFilter: false });
                    this.setItems();
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="people-btn people-btn--primary">
                  Apply
                </button>
              </div>
            </div>
          </form>
        )}

        <PeopleFilterChips
          filters={filters}
          columns={FILTER_COLUMNS}
          valueLabels={{
            role: filterOptions.role.reduce((result, option) => {
              result[String(option.value)] = option.text || String(option.value);
              return result;
            }, {}),
            userStatus: filterOptions.userStatus.reduce((result, option) => {
              result[String(option.value)] = option.text || String(option.value);
              return result;
            }, {}),
            tag: filterOptions.tag.reduce((result, option) => {
              result[String(option.value)] = option.text || String(option.value);
              return result;
            }, {}),
            loggedIn: { YES: 'Yes', NO: 'No' }
          }}
          onRemove={field => this.setState({ filters: { ...filters, [field]: '' } }, this.onApplyFilterClick)}
          onClear={this.onClearFilterClick}
        />

        {selectedCount > 0 && (
          <div className="people-selection">
            <span className="people-selection__summary">{selectedCount} selected</span>
            <div className="people-selection__actions">
              <button type="button" className="people-btn people-btn--secondary" onClick={this.onSendMessageClick}>
                <span aria-hidden="true">+</span> Create message
              </button>
              {this.props.user.activeRole === 'ADMIN' && (
                <button type="button" className="people-btn people-btn--secondary" onClick={this.onAccountSetupReminderClick}>
                  <FontAwesomeIcon icon={faEnvelope} /> Send setup reminder
                </button>
              )}
              <button type="button" className="people-btn people-btn--secondary" onClick={this.onUserTagAssignClick}>
                Assign tag
              </button>
              <button type="button" className="people-btn people-btn--secondary" onClick={this.onUserTagDeleteClick}>
                Remove tag
              </button>
              <button
                type="button"
                className="people-btn people-btn--secondary"
                disabled={selectedCount !== 1}
                onClick={this.onAddUserRoleClick}
              >
                <span aria-hidden="true">+</span> Add role
              </button>
              <button
                type="button"
                className="people-btn people-btn--secondary"
                disabled={selectedCount !== 1 || !canRevokeSelectedUser}
                onClick={this.onRevokeUserRoleClick}
              >
                Revoke role
              </button>
              {selectedCount === 1 && (
                <div className="people-selection__reports">
                  <button
                    type="button"
                    className="people-btn people-btn--secondary people-btn--iconLeft"
                    onClick={this.openReportsSelectionModal}
                  >
                    <span className="people-icon people-icon--reports" /> Reports
                  </button>
                </div>
              )}
            </div>
            <div className="people-toolbar__spacer" />
            <button type="button" className="people-selection__clear" onClick={this.onUnselectAllClick}>
              Clear selection
            </button>
          </div>
        )}

        <div className="people-tableCard">
          <div className="people-tableScroll">
            <table className="people-table users-modernTable">
              <thead>
                <tr>
                  <th className="people-table__check">
                    <div className="people-bulkSelect">
                      <button
                        type="button"
                        className={`people-bulkSelect__trigger ${
                          allPageSelected ? 'people-bulkSelect__trigger--checked' : ''
                        }`}
                        aria-label="Bulk select users"
                        aria-expanded={isSelectionMenuOpen}
                        onClick={event => {
                          event.stopPropagation();
                          this.setState({ isSelectionMenuOpen: !isSelectionMenuOpen });
                        }}
                      >
                        <span className="people-bulkSelect__box" />
                      </button>
                      {isSelectionMenuOpen && (
                        <div className="people-bulkSelect__menu">
                          <button type="button" onClick={toggleAllOnPage}>
                            Select this page
                          </button>
                          <button type="button" onClick={this.onSelectAllClick}>
                            Select all
                          </button>
                          <button type="button" disabled={selectedCount === 0} onClick={this.onUnselectAllClick}>
                            Clear selection
                          </button>
                        </div>
                      )}
                    </div>
                  </th>
                  {visibleColumns.map(column => {
                    const isSorted = sortColumnsName === column.field;
                    return (
                      <th
                        key={column.field}
                        onClick={column.isSort ? () => this.onTableSortClick(column.field) : undefined}
                        className={column.isSort ? 'people-table__sortable' : ''}
                      >
                        <span>{column.text}</span>
                        {column.isSort && (
                          <i className={`people-sort ${isSorted ? `people-sort--${sortDirection}` : ''}`} />
                        )}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td className="people-empty" colSpan={visibleColumns.length + 1}>
                      <ListEmptyState
                        icon={faUsers}
                        title={isDataFiltered ? 'No users match your filters' : 'No users or contacts yet'}
                        description={
                          isDataFiltered
                            ? 'Try changing or clearing the search and filters to see more people.'
                            : 'Students, parents, staff and other school contacts will appear here.'
                        }
                      />
                    </td>
                  </tr>
                ) : (
                  items.map(user => {
                    const isSelected = isSelectAllChecked ? !excludedIds.has(user.id) : selectedIds.has(user.id);
                    const isPreviewed = previewUserId === user.id;
                    return (
                      <tr
                        key={user.id}
                        data-selected={isSelected}
                        data-preview={isPreviewed}
                        onClick={() => this.onUserPreviewClick(user)}
                      >
                        <td className="people-table__check" onClick={event => event.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={event => this.onUserRowCheckboxClick(event, user)}
                          />
                        </td>
                        {visibleColumns.map(column => (
                          <td key={column.field}>{getCellValue(user, column)}</td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {total > 0 ? (
          <Pagination2
            modern
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
          />
        ) : null}
      </div>
    );
  }

  renderSummary(): React.ReactNode {
    const { currentTabIndex, previewUser } = this.state;

    if (!previewUser) {
      return null;
    }

    const fullName = this.getUserFullName(previewUser);
    const roles =
      this.getUserRoleNames(previewUser)
        .map(role => ROLE_SERVER_TO_CLIENT_MAPPING[role] || role)
        .join(', ') || 'No role';
    const email = getEmailOrMisEmail(previewUser) || 'No email';
    const tabs = ['Summary', 'Roles'];

    return (
      <>
        <div className="people-drawerScrim" onClick={this.closeUserPreview} />
        <aside className="people-drawer" role="dialog" aria-modal="true">
          <div className="people-drawer__head">
            {this.renderUserAvatar(previewUser, true)}
            <div className="people-drawer__identity">
              <h2>{fullName}</h2>
              <div>
                <span>{roles}</span>
                <i />
                <span>{email}</span>
              </div>
            </div>
            <button type="button" className="people-drawer__close" onClick={this.closeUserPreview} aria-label="Close">
              ×
            </button>
          </div>

          <div className="people-drawer__tabs">
            {tabs.map((tab, index) => (
              <button
                key={tab}
                type="button"
                className={currentTabIndex === index ? 'active' : ''}
                onClick={event => this.onSummaryTabClick(event, index)}
              >
                {tab}
                {index === 1 ? ` (${this.getUserRoleNames(previewUser).length})` : ''}
              </button>
            ))}
          </div>

          <div className="people-drawer__body">{this.getUserSummaryTabs()}</div>

          <div className="people-drawer__foot users-drawerFoot">
            <button
              type="button"
              className="people-btn people-btn--secondary"
              onClick={() => this.usePreviewUserForAction(this.onSendMessageClick)}
            >
              <FontAwesomeIcon icon={faEnvelope} /> Message
            </button>
            <button
              type="button"
              className="people-btn people-btn--secondary"
              onClick={() => this.usePreviewUserForAction(this.onUserTagAssignClick)}
            >
              <FontAwesomeIcon icon={faTags} /> Assign tag
            </button>
            <button
              type="button"
              className="people-btn people-btn--primary"
              onClick={() => this.setState({ currentTabIndex: 1 })}
            >
              <FontAwesomeIcon icon={faUserShield} /> Manage access
            </button>
          </div>
        </aside>
      </>
    );
  }

  onSummaryTabClick = (event: any, index: number): void => {
    event.preventDefault();
    this.setState({ currentTabIndex: index });
  };

  renderUserDetails(user: SchoolUser): React.ReactNode {
    const tags = this.getSafeUserTags(user);
    const rows = [
      ['Name', this.getUserFullName(user)],
      ['Email', getEmailOrMisEmail(user) || '-'],
      ['Phone', getPhoneOrMisPhone(user) || '-'],
      ['Status', getUserStatus(user) || '-'],
      [
        'Tags',
        tags.length > 0 ? this.renderUserTags(user, true) : <span className="users-accessEmpty">No tags assigned.</span>
      ]
    ];

    return (
      <div className="users-detailList">
        {rows.map(([label, value]) => (
          <div key={String(label)} className="users-detailRow">
            <span>{label}</span>
            <strong>{value}</strong>
          </div>
        ))}
      </div>
    );
  }

  updateUserPermissionInState(userId: string, permission: any): void {
    const updateUser = (user: SchoolUser): SchoolUser => {
      const permissions = [...propz.get(user, ['permissions'], [])];
      const permissionIndex = permissions.findIndex(item => item.id === permission.id);

      if (permissionIndex === -1) {
        permissions.push({ tags: [], ...permission });
      } else {
        permissions.splice(permissionIndex, 1, { tags: [], ...permission });
      }

      return { ...user, permissions };
    };

    this.setState(prevState => ({
      previewUser:
        prevState.previewUser && prevState.previewUser.id === userId
          ? updateUser(prevState.previewUser)
          : prevState.previewUser,
      selectedItems: prevState.selectedItems.map(user => (user.id === userId ? updateUser(user) : user)),
      items: prevState.items.map(user => (user.id === userId ? updateUser(user) : user))
    }));
  }

  removeUserPermissionFromState(userId: string, permissionId: string): void {
    const updateUser = (user: SchoolUser): SchoolUser => ({
      ...user,
      permissions: propz.get(user, ['permissions'], []).filter(permission => permission.id !== permissionId)
    });

    this.setState(prevState => ({
      previewUser:
        prevState.previewUser && prevState.previewUser.id === userId
          ? updateUser(prevState.previewUser)
          : prevState.previewUser,
      selectedItems: prevState.selectedItems.map(user => (user.id === userId ? updateUser(user) : user)),
      items: prevState.items.map(user => (user.id === userId ? updateUser(user) : user))
    }));
  }

  onInlineUserRoleAdd = (roleId: string): void => {
    const user = this.state.previewUser;

    if (!user || !roleId) {
      return;
    }

    if (roleId === ROLE.PARENT) {
      this.setState({
        selectedItems: [user],
        isSelectAllChecked: false,
        isAddRoleFormOpen: true,
        addRoleInitialPreset: ROLE.PARENT
      });
      return;
    }

    this.setState({ isLoading: true });

    const data =
      roleId === ROLE.TEACHER || roleId === ROLE.COACH ? { preset: roleId, sportIds: [] } : { preset: roleId };

    postUserPermission(this.props.user, user.id, data as any)
      .then(permission => {
        this.updateUserPermissionInState(user.id, permission);
        this.setState({ isLoading: false });
      })
      .catch(error => {
        console.error(error);
        this.setState({ isLoading: false });
      });
  };

  onInlineUserRoleRemove = (permission: any): void => {
    const user = this.state.previewUser;

    if (!user) {
      return;
    }

    this.setState({
      selectedItems: [user],
      revokePermissions: [permission],
      isConfirmRevokeRoleModalOpen: true
    });
  };

  renderInlineAddSelect(
    label: string,
    options: Array<{ id: string; name: string }>,
    onChange: (id: string) => void
  ): React.ReactNode {
    if (options.length === 0) {
      return null;
    }

    return (
      <select
        className="users-accessAddSelect"
        value=""
        onChange={event => {
          onChange(event.target.value);
          event.target.value = '';
        }}
      >
        <option value="" disabled hidden>
          {label}
        </option>
        {options.map(option => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    );
  }

  renderRemovableChip(label: string, onRemove: () => void, color?: string): React.ReactNode {
    return (
      <span className="users-accessChip" style={{ '--users-chip-color': color || '#227ebd' } as React.CSSProperties}>
        <i />
        <span>{label}</span>
        <button type="button" onClick={onRemove} aria-label={`Remove ${label}`}>
          ×
        </button>
      </span>
    );
  }

  getStudentDisplayName(student: any): string {
    const fullName = `${propz.get(student, ['firstName'], '')} ${propz.get(student, ['lastName'], '')}`.trim();
    return fullName || propz.get(student, ['name'], 'Student');
  }

  getStudentInitials(student: any): string {
    return `${propz.get(student, ['firstName'], '?').charAt(0)}${propz.get(student, ['lastName'], '').charAt(0)}`;
  }

  renderParentLinkedChild(permission: SchoolUserPermission, onRemove?: () => void): React.ReactNode {
    if (permission.preset !== ROLE.PARENT) {
      return null;
    }

    const student = propz.get(permission, ['student']);
    const studentId = propz.get(permission, ['studentId'], '');

    if (!student && !studentId) {
      return null;
    }

    const formName = propz.get(student, ['form', 'name'], '');
    const houseName = propz.get(student, ['house', 'name'], '');
    const meta = [formName, houseName].filter(item => item).join(' · ');

    return (
      <div className="users-linkedChild">
        {student ? (
          <div className="users-linkedChild__card">
            <span className="users-linkedChild__avatar">
              <span>{this.getStudentInitials(student)}</span>
            </span>
            <div className="users-linkedChild__main">
              <strong>{this.getStudentDisplayName(student)}</strong>
              <span>
                {[meta, permission.priority ? `Priority ${permission.priority}` : ''].filter(Boolean).join(' · ')}
              </span>
            </div>
            {onRemove ? (
              <button
                type="button"
                className="users-linkedChild__remove"
                onClick={onRemove}
                aria-label="Revoke parent access for this child"
              >
                ×
              </button>
            ) : null}
          </div>
        ) : (
          <div className="users-linkedChild__fallback">
            <span>
              Student ID: {studentId}
              {permission.priority ? ` · Priority ${permission.priority}` : ''}
            </span>
            {onRemove ? (
              <button type="button" className="users-linkedChild__remove" onClick={onRemove}>
                ×
              </button>
            ) : null}
          </div>
        )}
      </div>
    );
  }
  renderUserRoles(user: SchoolUser): React.ReactNode {
    const permissions = propz.get(user, ['permissions'], []);
    const staffPermissions = permissions.filter(permission => permission.preset !== ROLE.PARENT);
    const parentPermissions = permissions.filter(permission => permission.preset === ROLE.PARENT);
    const getSportName = (sportId: any): string => {
      if (sportId && typeof sportId === 'object' && (sportId.name || sportId.title)) {
        return sportId.name || sportId.title;
      }
      const normalizedId = String(propz.get(sportId, ['id'], propz.get(sportId, ['_id'], sportId)) || '');
      const sport = this.state.sports.find(
        item => String(propz.get(item, ['id'], propz.get(item, ['_id'], ''))) === normalizedId
      );
      return propz.get(sport, ['name'], propz.get(sport, ['title'], '')) || normalizedId;
    };
    const assignedRoleNames = permissions.map(permission => permission.preset);
    const roleOptions = ALL_SCHOOL_ROLES_ADDING_LIST.filter(
      role => role === ROLE.PARENT || assignedRoleNames.indexOf(role) === -1
    ).map(role => ({ id: role, name: ROLE_SERVER_TO_CLIENT_MAPPING[role] || role }));

    return (
      <div className="users-accessEditor">
        <section className="users-accessSection">
          <div className="users-accessSection__head">
            <span>Roles</span>
            {this.renderInlineAddSelect('+ Add role', roleOptions, roleId => this.onInlineUserRoleAdd(roleId))}
          </div>
          <div className="users-roleCards">
            {permissions.length === 0 ? <span className="users-accessEmpty">No roles assigned yet.</span> : null}
            {staffPermissions.map(permission => {
              const sports = propz.get(permission, ['sports'], []);
              const sportIds = propz.get(permission, ['sportIds'], []);
              return (
                <div key={permission.id} className="users-roleCard">
                  <div className="users-roleCard__top">
                    {this.renderRemovableChip(
                      ROLE_SERVER_TO_CLIENT_MAPPING[permission.preset] || permission.preset,
                      () => this.onInlineUserRoleRemove(permission),
                      '#227ebd'
                    )}
                  </div>
                  {permission.status || permission.priority ? (
                    <div className="users-roleCard__meta">
                      {permission.status ? (
                        <span
                          className={`users-roleStatus users-roleStatus--${String(permission.status).toLowerCase()}`}
                        >
                          {permission.status}
                        </span>
                      ) : null}
                      {permission.priority ? <span>Priority {permission.priority}</span> : null}
                    </div>
                  ) : null}
                  {sports.length > 0 || sportIds.length > 0 ? (
                    <div className="users-roleCard__sports">
                      <span className="users-accessLabel">Activities/Sports</span>
                      <div className="users-accessChips">
                        {sports.length > 0
                          ? sports.map(sport => (
                              <span key={sport.id || sport.name} className="users-accessReadChip">
                                {sport.name || sport.title || sport.id}
                              </span>
                            ))
                          : sportIds.map(sportId => (
                              <span
                                key={String(propz.get(sportId, ['id'], propz.get(sportId, ['_id'], sportId)))}
                                className="users-accessReadChip"
                              >
                                {getSportName(sportId)}
                              </span>
                            ))}
                      </div>
                    </div>
                  ) : null}
                </div>
              );
            })}
            {parentPermissions.length > 0 ? (
              <div className="users-roleCard users-parentRoleCard">
                <div className="users-roleCard__top">
                  <span className="users-accessChip" style={{ '--users-chip-color': '#227ebd' } as React.CSSProperties}>
                    <i />
                    <span>Parent</span>
                  </span>
                  <span className="users-parentRoleCard__count">
                    {parentPermissions.length} {parentPermissions.length === 1 ? 'child' : 'children'}
                  </span>
                </div>
                <div className="users-parentPermissions">
                  {parentPermissions.map(permission => (
                    <div key={permission.id} className="users-parentPermission">
                      {this.renderParentLinkedChild(permission, () => this.onInlineUserRoleRemove(permission))}
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </section>
      </div>
    );
  }

  getUserSummaryTabs(): React.ReactNode {
    const { currentTabIndex, previewUser } = this.state;

    if (!previewUser) {
      return null;
    }

    switch (currentTabIndex) {
      case 0:
        return this.renderUserDetails(previewUser);
      case 1:
        return this.renderUserRoles(previewUser);
      default:
        console.error('Users.tsx \n Wrong tab index ' + currentTabIndex);
        return null;
    }
  }
  render() {
    const {
      isLoading,
      isMessageModalOpen,
      isUserTagModalOpen,
      isUserTagDeleteModalOpen,
      isConfirmRevokeRoleModalOpen,
      isRevokeRoleFormOpen,
      isAddRoleFormOpen,
      isUserActivityDetailsReportModalOpen,
      isStudentActivityReportModalOpen,
      isParentActivityReportModalOpen,
      isReportsSelectionModalOpen,
      isAccountSetupReminderModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isMessageModalOpen ||
      isUserTagModalOpen ||
      isUserTagDeleteModalOpen ||
      isConfirmRevokeRoleModalOpen ||
      isRevokeRoleFormOpen ||
      isUserActivityDetailsReportModalOpen ||
      isStudentActivityReportModalOpen ||
      isParentActivityReportModalOpen ||
      isReportsSelectionModalOpen ||
      isAccountSetupReminderModalOpen ||
      isAddRoleFormOpen
        ? 'usersPage schoolPeoplePage modal-open'
        : 'usersPage schoolPeoplePage';

    return (
      <div className={classes}>
        {this.renderUserTagAssignModal()}
        {this.renderUserTagDeleteModal()}
        {this.renderConfirmRevokeRoleModalOpen()}
        {this.renderRevokeRoleFormModal()}
        {this.renderAddRoleFormModal()}
        {this.renderGMWizard()}
        {this.renderUserActivityDetailsReportFormModal()}
        {this.renderStudentActivityReportFormModal()}
        {this.renderParentActivityReportFormModal()}
        {this.renderReportsSelectionModal()}
        {this.renderAccountSetupReminderModal()}
        <PeopleListPageHeader title="All users and contacts" total={this.state.total} />
        <div className="people-pageWrap">
          {this.renderUsersTable()}
          {!isAddRoleFormOpen && this.renderSummary()}
        </div>
      </div>
    );
  }
}
